/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
} from "@carbon/react";
import React from "react";
import InfoAlert from "../../ui/InfoAlert";
import { DATA_TABLE_GENERAL_TRANSLATIONS } from "../../translations/util";

export interface IProps {
  rows: any;
  infoAlertHeading?: string;
  infoAlertSubtext?: string;
  headers: Array<{ key: string; header: string; isSortable?: boolean }>;
  sortByField?: string;
  sortDirection?: "desc" | "asc";
  handleSort?: any;
}

// https://github.com/carbon-design-system/carbon/blob/main/packages/react/src/components/DataTable/TableHeader.tsx#L27
const getSortDirection = (sortDirection) => {
  if (!sortDirection) return undefined;
  if (sortDirection === "desc") return "DESC";

  return "ASC";
};

const getNewSortDirection = (sortDirection) => {
  if (!sortDirection) return "asc";
  if (sortDirection === "desc") return "asc";

  return "desc";
};

const ESDataTable = ({
  rows,
  infoAlertHeading = DATA_TABLE_GENERAL_TRANSLATIONS.noDataForSelectedOrg
    .infoAlert.heading,
  infoAlertSubtext = DATA_TABLE_GENERAL_TRANSLATIONS.noDataForSelectedOrg
    .infoAlert.subText,
  headers,
  sortByField,
  sortDirection,
  handleSort,
}: IProps) => {
  return (
    <DataTable rows={rows} headers={headers}>
      {({ rows, headers, getTableProps, getHeaderProps, getRowProps }) => (
        <Table {...getTableProps()} data-cy="dataTable">
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableHeader
                  data-cy={`${header.key}-tableHeader`}
                  {...getHeaderProps({ header, isSortable: header.isSortable })}
                  onClick={
                    header.isSortable
                      ? handleSort(
                          header.key,
                          getNewSortDirection(sortDirection)
                        )
                      : undefined
                  }
                  isSortHeader={header.key === sortByField}
                  sortDirection={getSortDirection(sortDirection)}
                >
                  {header.header}
                </TableHeader>
              ))}
            </TableRow>
          </TableHead>

          {rows.length > 0 ? (
            <TableBody data-cy="tableBody">
              {rows.map((row, rowIndex) => (
                <TableRow
                  {...getRowProps({ row })}
                  data-cy={`tableRow-${rowIndex}`}
                >
                  {row.cells.map((cell, cellIndex) => (
                    <TableCell
                      key={cell.id}
                      data-cy={`tableCell-${rowIndex}${cellIndex}`}
                    >
                      {cell.value}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colspan={headers.length}>
                  <InfoAlert
                    heading={infoAlertHeading}
                    subText={infoAlertSubtext}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      )}
    </DataTable>
  );
};

export default ESDataTable;
